import Config from '../../config';
import Blockv from '../../managers/blockv';
import Alert from '../../util/alert';
import {
  UpgradePayload,
  CreateUserPayload,
  CaptchaPayload,
} from '../../managers/blockv/manager/publisher';
import Errors from '../../managers/errors';

export default class Presenter {
  constructor(model) {
    this.model = model;
    this.redirectUri = encodeURIComponent(Config.oauthRedirect);
  }

  async onAttach() {
    try {
      this.model.loading = true;
      const params = await Blockv.checkForLogin();
      if (Blockv.hasValidToken) {
        if (params && params.consentKind && params.consentVersion) {
          await Blockv.user.consent(params.consentKind, parseInt(params.consentVersion, 10));
        }
        const user = await Blockv.user.current.get();
        if (Blockv.user.isPublisher(user)) {
          window.location.hash = '#/workspace';
        } else if (params?.userAction) {
          this.model.tab = 'upgrade';
        } else {
          const tokens = await Blockv.user.current.tokens.get();
          this.model.token = tokens.find((token) => token.properties.is_default)?.properties?.token;
          this.model.tab = 'warning';
        }
      }
    } catch (error) {
      Errors.show(error);
    }
    this.model.loading = false;
  }

  onIconLoaded(element) {
    if (element) {
      const rect = element.getBoundingClientRect();
      const iconStyle = {
        width: '220px',
        top: `${rect.top - 86}px`,
        left: `${rect.left - 56}px`,
      };
      window.removeLoader(600, iconStyle);
    }
  }

  onLoginClick() {
    if (this.model.consent) {
      Blockv.login({
        consentKind: Config.consentKind,
        consentVersion: Config.consentVersion,
        userAction: '1',
      });
    } else this.model.consentError = true;
  }

  onContinueClick() {
    this.model.tab = 'upgrade';
  }

  onConsentClick() {
    this.model.consent = !this.model.consent;
    this.model.consentError = false;
  }

  onUpgradeNameChange(value) {
    this.model.upgradeName = value;
  }

  onPasswordChange(value) {
    this.model.password = value;
  }

  onUpgradeFqdnChange(value) {
    let updated = value
      .replace(/[^a-z0-9--]/gi, '')
      .replace(/([-])(?=\1)/gi, '')
      .toLowerCase();
    if (value.length > 23) {
      updated = value.substring(0, 17);
    }
    this.model.upgradeFqdn = updated;
  }

  onUpgradeCaptchaChange(value) {
    this.model.upgradeCaptcha = value;
  }

  onUpgradeFieldChange(field, value) {
    const data = {};
    data[field] = value;
    this.model.value = data;
  }

  onPublisherConsentClick() {
    this.model.publisherConsent = !this.model.publisherConsent;
    this.model.publisherConsentError = false;
  }

  onBackClick() {
    this.model.tab = 'main';
    Blockv.clearToken();
  }

  clear() {
    this.model.upgradeName = '';
    this.model.upgradeFqdn = '';
    this.model.upgradeCaptcha = '';
    this.model.errorName = '';
    this.model.errorFqdn = '';
    this.model.errorCaptcha = '';
  }

  onCaptchaLoad(reload, id) {
    this.captchaReload = reload;
    this.captchaId = id;
    console.log(id);
  }

  onUpgradeClick() {
    let error = false;
    if (!(this.model.upgradeName?.length > 0)) {
      this.model.errorName = 'login.upgrade.error_required_field';
      error = true;
    } else this.model.errorName = '';

    if (!(this.model.upgradeFqdn?.length > 0)) {
      this.model.errorFqdn = 'login.upgrade.error_required_field';
      error = true;
    } else this.model.errorFqdn = '';

    if (!(this.model.upgradeCaptcha?.length > 0)) {
      this.model.errorCaptcha = 'login.upgrade.error_required_field';
      error = true;
    } else this.model.errorCaptcha = '';

    const { password } = this.model;
    if (password.length === 0) {
      this.model.errorPassword = 'login.upgrade.error_required_field';
      error = true;
    } else if (password.length < 10) {
      this.model.errorPassword = 'login.upgrade.error_password_length';
      error = true;
    } else if (!/[a-zA-Z]/g.test(password) || !/[0-9]/g.test(password)) {
      this.model.errorPassword = 'login.upgrade.error_password_content';
      error = true;
    } else this.model.errorPassword = '';

    this.model.publisherConsentError = !this.model.publisherConsent;
    if (error || !this.model.publisherConsent) return;

    this.model.loading = true;
    Blockv.publisher
      .upgrade(
        new UpgradePayload(
          this.model.upgradeName,
          '',
          '',
          '',
          '',
          `blockv.${this.model.upgradeFqdn}`,
          new CreateUserPayload(
            `blockv.${this.model.upgradeFqdn}@blockv.io`,
            'email',
            '',
            'Trash',
            this.model.upgradeName
          ),
          password
        ),
        new CaptchaPayload(this.captchaId, this.model.upgradeCaptcha)
      )
      .then(() => Blockv.user.current.tokens.get())
      .then((tokens) => {
        this.model.loading = false;
        this.model.tab = 'main';
        return Alert.notify(
          'login.upgrade.success_title',
          'login.upgrade.success_details',
          'login.upgrade.success_action'
        ).then(() => tokens);
      })
      .then((tokens) =>
        Blockv.logout()
          .catch((err) => console.warn(err))
          .then(() => tokens)
      )
      .then((tokens) => {
        const emailToken = tokens.find((token) => token.properties.token_type === 'email');
        const phoneToken = tokens.find((token) => token.properties.token_type === 'phone_number');
        const param = {};
        if (emailToken || phoneToken) {
          param.token = (phoneToken || emailToken).properties.token;
          param.skip_token = true;
        }
        Blockv.login(param);
      })
      .catch((err) => {
        this.model.loading = false;
        Errors.show(err);
      });
  }
}
